export const homepageUrl = '/';
export const homepage2Url = '/forum/homepage2/';


